export const SET_MENU = 'menu/set-menu-items';
export const SET_MENU_CATEGORIES = 'menu/set-menu-categories';
